import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import { currentLanguage } from '../../../i18n';
import { styles } from '../styles';

const getMonth = (locale, idx) => {
  let objDate = new Date();
  objDate.setDate(1);
  objDate.setMonth(idx);

  let month = objDate.toLocaleString(locale, { month: "long" });
  return month;
}

const deliveryDate = (d) => {
  const lang = currentLanguage();
  const v = d.context.entities.deliveryPeriods[d.deliveryDate.value];
  if (v == null) {
    return '';
  }

  const dt = new Date(v.s);
  const month = getMonth(lang, dt.getMonth());
  return month;
}

export const ProductLineItemLineInfo = ({ position, product }) => (
  <View style={[styles.productLineItemLineInfo, styles.row]}>
    <Text style={styles.column.position}>{position + 1}</Text>
    <Text style={styles.column.collection}>{product.collection}</Text>
    <View style={styles.column.model}>
      <View>
        <Text>{product.name}</Text>
      </View>
      <View>
        <Text>{product.model}</Text>
      </View>
    </View>
    <Text style={styles.column.color}>{product.color}</Text>
    <Text style={styles.column.deliveryDate}>{deliveryDate(product)}</Text>
    <Text style={styles.column.amount}>{product.amount}</Text>
  </View>
);
